import Channel from '../utils/channel';
import Hub from './hub';

import { Insert, Update, Delete } from './live';

let [insert, update, remove] = Hub.prop( 'issues' )
     .split( 'commentInsert', 'commentUpdate', 'commentDelete' );

insert = insert.flatten().map( attrs => new Insert( attrs ) );
update = update.flatten().map( attrs => new Update( attrs ) );
remove = remove.flatten().map( attrs => new Delete( attrs ) );

export default new Channel().merge( insert, update, remove );


// WEBPACK FOOTER //
// ./src/js/service/comments.js